import {
  CAREER_POPUP_DATA,
  CAREER_POPUP_DATA_FAIL,
  CAREER_POPUP_DATA_SUCCESS,
  HIDE_CAREER_POPUP_DATA,
  UPDATE_CAREER_PAGE_INTEGRATION_LINK,
  UPDATE_CAREER_PAGE_INTEGRATION_LINK_FAIL,
  UPDATE_CAREER_PAGE_INTEGRATION_LINK_SUCCESS,
  UPDATE_CAREER_POPUP_DATA,
  UPDATE_CAREER_POPUP_DATA_FAIL,
  UPDATE_CAREER_POPUP_DATA_SUCCESS
} from "./actionTypes";

const initialState = {
  loader: false,
  updateLoader: false,
  getConfigDataSuccess: null,
  getConfigDataError: null,
  configUpdateDataSuccess: null,
};

const getCareerPopUpReducer = (state = initialState, action) => {
  switch (action.type) {
    case CAREER_POPUP_DATA:
      state = {
        ...state,
        loader: true,
        getConfigDataSuccess: null,
        getConfigDataError: null,
      };
      break;
    case CAREER_POPUP_DATA_FAIL:
      state = {
        ...state,
        loader: false,
        getConfigDataSuccess: null,
        getConfigDataError: action.payload,
      };
      break;
    case CAREER_POPUP_DATA_SUCCESS:
      state = {
        ...state,
        loader: false,
        getConfigDataSuccess: action.payload,
        getConfigDataError: null,
      };
      break;
    case UPDATE_CAREER_POPUP_DATA:
      state = {
        ...state,
        updateLoader: true,
        configUpdateDataSuccess: null,
        getConfigDataError: null,
      };
      break;
    case UPDATE_CAREER_POPUP_DATA_SUCCESS:
      state = {
        ...state,
        updateLoader: false,
        configUpdateDataSuccess: action.payload,
        getConfigDataError: null,
      };
      break;
    case UPDATE_CAREER_POPUP_DATA_FAIL:
      state = {
        ...state,
        updateLoader: false,
        configUpdateDataSuccess: null,
        getConfigDataError: action.payload,
      };
      break;
    case HIDE_CAREER_POPUP_DATA:
      state = {
        ...state,
        configUpdateDataSuccess: null,
        getConfigDataError: null,
      };
      break;
      case UPDATE_CAREER_PAGE_INTEGRATION_LINK:
        state = {
          ...state,
          loader: false,
          updateLoader: true,
          getConfigDataSuccess: null,
          getConfigDataError: null,
        };
        break;
      case UPDATE_CAREER_PAGE_INTEGRATION_LINK_SUCCESS:
        state = {
          ...state,
          updateLoader: false,
          loader: false,
          configUpdateDataSuccess: action.payload,
          getConfigDataError: null,
        };
        break;
      case UPDATE_CAREER_PAGE_INTEGRATION_LINK_FAIL:
        state = {
          ...state,
          updateLoader: false,
          getConfigDataError: action.payload,
          configUpdateDataSuccess: null,
        };
        break;
    default:
      state = { ...state };
      break;
  }
  return state;
};
export default getCareerPopUpReducer;
